import { Component, inject } from '@angular/core';
import { SeoService } from '../core/seo.service';
import { FortuneWidgetComponent } from '../widgets/fortune/fortune-widget.component';
import { FortuneCategoryFlowComponent } from '../widgets/fortune-category/fortune-category-flow.component';
import { SiteConfigService } from '../core/site-config.service';
import { I18nService } from '../core/i18n.service';

@Component({
  selector: 'app-fortune-page',
  imports: [FortuneWidgetComponent, FortuneCategoryFlowComponent],
  template: `
    @if (site.usesSalesModel('categoryOffer')) { <app-fortune-category-flow /> }
    @else { <app-fortune-widget /> }
  `
})
export class FortunePage {
  private readonly seo = inject(SeoService);
  protected readonly site = inject(SiteConfigService);
  private readonly i18n = inject(I18nService);

  constructor() {
    const commerce = this.site.enabled('commerce') && !this.site.experience('fortune');
    const brandName = this.site.config().name || this.site.config().domain;
    this.seo.setPage({
      title: commerce ? `Products | ${brandName}` : this.i18n.t('fortuneSeoTitle'),
      description: commerce
        ? `Explore ${brandName} products by category, design and price.`
        : this.i18n.t('fortuneSeoDescription'),
      path: this.i18n.routePath('fortune')
    });
  }
}
